<template>
    <el-table-column v-bind="$attrs">

        <!-- <template #header="{ column }" v-if="$attrs.filter">
          <column-header :column="column" :description="$attrs.description" :filter="$attrs.filter"></column-header>
        </template> -->

        <template #default="{ row }" v-if="!$attrs.type">
            <template v-if="children && showChildren.length > 0">
                <ScTableColumn v-bind="child" v-for="(child, index) in showChildren" :key="index"></ScTableColumn>
            </template>
            <template v-else-if="row.__search">
                <table-row-filter :column="column" :row="row"></table-row-filter>
            </template>
            <template v-else-if="colDef && colDef.component">
                <component :is="colDef.component" v-bind="$attrs" :view="view" :row="row" :column="column" :format="fmtDef"></component>
            </template>
            <!-- <template v-else-if="fmtDef">
              {{ fmtDef.format(row[column.prop || ""], row, column) }}
            </template> -->
            <!--      过滤器-->

            <template v-else>
                {{ row[column.prop || ''] || '' }}
            </template>
        </template>
    </el-table-column>
</template>

<script>
import {computed} from 'vue'
import ColumnHeader from '../column-header.vue'
import {getColumnComponent} from './../columnComponent'
import {getColumnFormat} from '../columnFormat'
import TableRowFilter from '@/components/pro-table/filter/table-row-filter.vue'

export default {
    name: 'ScTableColumn',
    components: {TableRowFilter, ColumnHeader},
    props: {
        children: {
            type: Array,
            default: null,
        },
        format: {
            type: String,
            default: null,
        },
        view: {
            type: Object,
            default: null,
        },
        column: {
            type: Object
        }
    },
    emits: ['column-filter-change'],
    setup(props) {
        const showChildren = computed(() =>
            Array.from(props.children || []).filter((i) => !i.hide)
        )
        const colDef = computed(() => {
            return getColumnComponent(props.view?.type || 'default')
        })
        const fmtDef = computed(() => {
            return getColumnFormat(props?.format)
        })

        return {
            showChildren,
            colDef,
            fmtDef,
        }
    },
}
</script>

<style>

</style>